import { sleep } from "@conectate/components/ct-helpers";

import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Notifications {
	async getAllNotifications(uid: string, params: any) {
		const r = await xget<{ notifications: PGSchema.notifications[] }>(`/users/${uid}/notifications`, params);
		return r;
	}

	async deleteNotification(uid: string, _id: PGSchema.notifications["id"]) {
		const r = await xhttp<{ notification: PGSchema.notifications[] }>(`/users/${uid}/notifications/${_id}`, "DELETE");
		return r;
	}

	async testNotifications(timeout?: number) {
		if (timeout) await sleep(timeout);
		return xget<{ ok: boolean }>(`/users/me/notifications/test`);
	}

	async testNotificationsID(token: string) {
		return xhttp(`/fcm`, "POST", { token });
	}

	async subscribeToTopic(topic: string, token: string) {
		const r = await xhttp(`/users/me/subscribe/${topic}`, "POST", { tk: token });
		return r;
	}
	async getDevices() {
		return xget<{ devices: PGSchema.users_devices[] }>(`/users/me/devices`);
	}

	async addDevice(token?: string, device_id?: number | bigint) {
		if (window.app.sessionStorage.isInSession) {
			return Promise.resolve([{ device: { id: new Date().getTime() } }, undefined, { status: 200 }]) as any;
		}
		return xhttp<{ device: PGSchema.users_devices }>(`/users/me/devices`, "POST", { token: token, device_id });
	}

	async editDevice(id: number | bigint, data: Partial<PGSchema.users_devices>) {
		if (window.app.sessionStorage.isInSession) {
			return Promise.resolve([{}, undefined, { status: 200 }]) as any;
		}
		const r = await xhttp(`/users/me/devices/${id}`, "PUT", { device: data });
		return r;
	}

	async deleteDevice(id: number | bigint, token?: string) {
		if (window.app.sessionStorage.isInSession) {
			return Promise.resolve([{}, undefined, { status: 200 }]) as any;
		}
		const r = await xhttp(`/users/me/devices/${id}`, "DELETE", { token });
		return r;
	}
}
